import {Stack, Typography} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import LanguageListDisplay from "./LanguageListDisplay";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function ProcessingResourceDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [objList, setObjList] = useState(props.objList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!objList || objList.length === 0) return null;

  return (
    <div>
      {/* Pivot Language Heading */}
      <Typography variant="h4" noWrap className="section--title">{topLabel}</Typography>
      {objList.getObjList().map((item, index) => {
        // console.log(item);
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {!item.mediaType.isEmpty() && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.msmediaType, "mediaType")}
                </Typography>
                {item.mediaType.getList().map((mediaTypeItem, index) => (
                  <div key={index}>
                    {getLabel(mediaTypeItem.getValue(), "")}
                  </div>
                ))}
              </div>
            )}
            {!item.format.isEmpty() && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.format, "format")}
                </Typography>
                {item.format.getList().map((formatItem, index) => (
                  <div key={index}>
                    {getLabel(formatItem.getValue(), "")}
                  </div>
                ))}
              </div>
            )}
            {!isEmpty(getLabel(item.processingResourceType.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.processingResourceType, "processingResourceType")}
                </Typography>
                <Typography variant="body1">{getLabel(item.processingResourceType.getValue())}</Typography>
              </div>
            )}
            <div>
              <LanguageListDisplay languageList={item.getLanguagesList()} defaultLanguage={defaultLanguage} mappings={mappings}
                topLabel={getLabel(keys.mslanguage, "language")} />
            </div>
          </Stack>
        );
      })}


    </div>
  );
}
